import React from 'react';
import { useTranslation } from 'react-i18next';
import useSeo from '../hooks/useSeo';
import { usePageContent } from './home/pageContent';
import { useSiteContent } from './home/siteContent';
import { PageHero, PageShell } from './home/blocks';
import PricingSection from './home/PricingSection';
import CtaBanner from './home/CtaBanner';

/* Content: Admin → Landingspagina → Prijzen (plans and prices: Admin → Abonnementen). */
const Pricing = () => {
  const { t } = useTranslation();
  const { lang, cms, content } = usePageContent('pricing');
  const { content: site } = useSiteContent();

  useSeo({
    path: '/pricing',
    lang,
    title: cms?.seo?.title || t('pricing_page.seo_title'),
    description:
      cms?.seo?.description || t('pricing_page.seo_description'),
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'Product',
      name: 'WowProfit.io',
      description: 'Winst- en margeanalyse voor WooCommerce-webshops.',
      brand: { '@type': 'Brand', name: 'WowProfit.io' },
      offers: [
        { '@type': 'Offer', name: 'Starter (maandelijks)', price: '9.95', priceCurrency: 'EUR', availability: 'https://schema.org/InStock' },
        { '@type': 'Offer', name: 'Professional (maandelijks)', price: '19.95', priceCurrency: 'EUR', availability: 'https://schema.org/InStock' },
        { '@type': 'Offer', name: 'Premium (maandelijks)', price: '29.95', priceCurrency: 'EUR', availability: 'https://schema.org/InStock' },
        { '@type': 'Offer', name: 'Starter (jaarlijks)', price: '99.95', priceCurrency: 'EUR', availability: 'https://schema.org/InStock' },
        { '@type': 'Offer', name: 'Professional (jaarlijks)', price: '195', priceCurrency: 'EUR', availability: 'https://schema.org/InStock' },
        { '@type': 'Offer', name: 'Premium (jaarlijks)', price: '295', priceCurrency: 'EUR', availability: 'https://schema.org/InStock' },
      ],
    },
  });

  return (
    <PageShell testId="pricing-page">
      <PageHero hero={content.hero} />
      <PricingSection pricing={site.pricing} heading={false} />
      <CtaBanner cta={content.cta} />
    </PageShell>
  );
};

export default Pricing;
